const truncateString = (str = '', num = 50) => {
  if (typeof str !== 'string') return '';

  if (str.length > num) {
    return `${str.slice(0, num)}...`;
  }
  return str;
};

export { truncateString };
